import React from 'react'
import ReactDOM from 'react-dom'
import StudentExceptions from './components/StudentExceptions'

export let startStudentExceptions = (
  coursenum,
  studentPK,
  studentName,
  studentEmail,
  activityPK,
  activityTitle,
  accessData,
  lateData,
  timeData
) => {
  ReactDOM.render(
    <StudentExceptions
      coursenum={coursenum}
      studentPK={studentPK}
      studentName={studentName}
      studentEmail={studentEmail}
      activityPK={activityPK}
      activityTitle={activityTitle}
      accessData={accessData}
      lateData={lateData}
      timeData={timeData}
    />,
    document.getElementById('react-app')
  )
}
